import React from 'react';
import './Card2.css';
import card2back from '../../assets/carteiracell.png';

const Card2 = () => {
  return (
    <section className="uen-section">
      <div className="uen-container">
        
        <h2 className="uen-title">
          Junte-se a milhares de estudantes e <br />
          garanta a sua meia entrada com a Uen
        </h2>

        <div className="uen-content-wrapper">
          
          <div className="uen-col left">
            <div className="uen-info-item">
              <div className="uen-icon-circle"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chart-line-icon lucide-chart-line"><path d="M3 3v16a2 2 0 0 0 2 2h16"/><path d="m19 9-5 5-4-4-3 3"/></svg></div>
              <p>Mais de 50 mil emissões de carteirinhas</p>
            </div>
            
            <div className="uen-info-item">
              <div className="uen-icon-circle"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-clapperboard-icon lucide-clapperboard"><path d="m12.296 3.464 3.02 3.956"/><path d="M20.2 6 3 11l-.9-2.4c-.3-1.1.3-2.2 1.3-2.5l13.5-4c1.1-.3 2.2.3 2.5 1.3z"/><path d="M3 11h18v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><path d="m6.18 5.276 3.1 3.899"/></svg></div>
              <p>Aceitas em cinemas, shows e eventos em todo o Brasil</p>
            </div>
          </div>

          <div className="uen-center-stage">
            {/* Elemento de design para profundidade */}
            <div className="glass-plate"></div>
            
            <img 
              src={card2back} 
              alt="Carteira Digital Uen" 
              className="uen-person-img"
            />
          </div>

          <div className="uen-col right">
            <div className="uen-info-item">
              <div className="uen-icon-circle"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-map-pin-icon lucide-map-pin"><path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"/><circle cx="12" cy="10" r="3"/></svg></div>
              <p>Atendimento em todos os estados</p>
            </div>

            <div className="uen-info-item">
              <div className="uen-icon-circle"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-map-pinned-icon lucide-map-pinned"><path d="M18 8c0 3.613-3.869 7.429-5.393 8.795a1 1 0 0 1-1.214 0C9.87 15.429 6 11.613 6 8a6 6 0 0 1 12 0"/><circle cx="12" cy="8" r="2"/><path d="M8.714 14h-3.71a1 1 0 0 0-.948.683l-2.004 6A1 1 0 0 0 3 22h18a1 1 0 0 0 .948-1.316l-2-6a1 1 0 0 0-.949-.684h-3.712"/></svg></div>
              <p>Praticidade com a sua carteirinha em qualquer lugar</p>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Card2;